import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import { IS_API_GATEWAY } from '@personal-area/global/http/models';

import { Country } from '../models/country';

export const dictURLs = {
  // get list of countries
  list: `/v7/countries`,
};

interface CountryV3Response {
  items: { [key: string]: Country };
}

@Injectable({ providedIn: 'root' })
export class DictionaryService {
  /**
   * Constructor.
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  /**
   * Fetch countries from API.
   * @returns {Country[]} Countries list
   */
  fetchCountries(includeDisabled = false): Observable<Country[]> {
    return this._http
      .get<CountryV3Response>(dictURLs.list, {
        params: {
          includeDisabled: includeDisabled ? '1' : '0',
          license: 'FSC', // Global
        },
        context: new HttpContext().set(IS_API_GATEWAY, true),
      })
      .pipe(
        map((resp: CountryV3Response) =>
          Object.keys(resp.items).map((k) => resp.items[k]),
        ),
      );
  }
}
